module.exports = __webpack_public_path__ + "img/infography-lg.06868a0c.png";